// Pure JS (no JSX imports) so it runs under `node --test`.

/**
 * Stop bar label: "PORT, COUNTRY" using the stop's own country. Without one, the
 * card's country applies only to the card's own arrival port; other ports show alone.
 */
export const stopCountryLabel = ({ port, stopCountry, cardPort, cardCountry }) => {
  const p = String(port || '').trim();
  const samePod = p !== '' && p.toUpperCase() === String(cardPort || '').trim().toUpperCase();
  const country = String(stopCountry || '').trim() || (samePod ? String(cardCountry || '').trim() : '');
  const name = samePod ? String(cardPort).trim() : p;
  if (name && country) return `${name}, ${country}`;
  return name || country || null;
};
